/** @jsx jsx */
import { jsx, Flex } from 'theme-ui'

const Main = (props) => (
    <Flex as="main"
        sx={{
            flexDirection: 'column',
            minHeight: '100vh',
            width: '100%'
        }}>
        {props.children}
    </Flex>
)

Main.defaultProps = {
    display: 'flex',
}

export default Main

